import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { SaveShareLinkType, ShareLink } from '@/models/shareModels';
import { createShareLink, getShare, saveShareLink } from '@/services/api';

const shareApi = createApi({
  reducerPath: 'shareApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getShareLink: builder.query<ShareLink | undefined, number>({
      queryFn: async (shareLinkId) => {
        try {
          const data = await getShare(shareLinkId);
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),

    saveShareLink: builder.mutation<ShareLink, SaveShareLinkType>({
      queryFn: async ({ uid, ...body }) => {
        try {
          if (!uid) {
            const data = await createShareLink(body);
            return { data };
          }
          const data = await saveShareLink({ ...body, uid });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

export default shareApi;

export const { useGetShareLinkQuery, useSaveShareLinkMutation } = shareApi;
